export default errorCode => {
  switch (errorCode) {
    case 'LimitExceededException':
      return 'Too many tries. Try again LATER.';
    case 'UserNotFoundException':
    case 'NotAuthorizedException':
      return 'Credentials you gave is wrong or your account has been disabled.';
    case 'PasswordResetRequiredException':
      return "Reset your password by going through the 'Forgot password' step";
    case 'UserNotConfirmedException':
      return "You haven't verified your email. Check it for the code.";
    case 'CodeMismatchException':
      return 'Verification code is wrong. Please double check.';
    case 'NEW_PASSWORD_REQUIRED':
      return 'Please change your password.';
    default:
      console.log(errorCode);
      return 'Something unexceptionally terrible went wrong. Contact admin!';
  }
};
